const listSwimEnv = [
  { value: "Piscine", label: "Piscine" },
  { value: "Lac", label: "Lac" },
  { value: "Mer", label: "Mer" },
  { value: "Rivière", label: "Rivière" },
  { value: "Plan d'eau", label: "Plan d'eau" },
];

export default listSwimEnv;
